
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import editar from './lista-buscador-presets-editar.vue';
    import { IColumna } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.lib';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Tipos as TiposPedido } from '@/__env/lib/Ventas/Pedidos/Pedido.types';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import observaciones from './barra-lateral-observaciones.vue';
    import totales from './barra-lateral-totales.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            totales,
            observaciones,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Pedido() { return this.Controlador.Pedido; }
        public get Iniciado() { return this.Controlador.EdicionPedido.Iniciado; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
            {

            }
        }

        public Problemas: string[] = [];
        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            if ( this.Intervalo )
                clearInterval( this.Intervalo );
            this.Eventos.forEach( x => x() );
        }

        public Intervalo: any = null;
        mounted()
        {
            let self = this;
            this.Intervalo = setInterval( () => self.onCambios(), 1000 );
            //this.Pedido.ComprobarFacturacion();
        }

        async onCambios()
        {
            this.Problemas.clear();
            if ( this.Iniciado )
                this.Problemas = await this.Controlador.EdicionPedido.ComprobarErrores();
        }

        Cerrar()
        {
            this.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
